// Aplica/limpa a paleta de accent do app (replica baseada em tema_cor da
// empresa). Setamos as CSS variables INLINE em document.documentElement
// pra vencer tanto :root (dark) quanto [data-theme="light"] que estao no
// globals.css.

import { APP_THEMES } from './constants';

// Lista das vars sobrescritas — mantida em um lugar so pra clear ser
// simetrico ao apply.
const VAR_KEYS = [
  '--primary',
  '--primary-2',
  '--primary-soft',
  '--primary-soft-2',
  '--primary-line',
  '--shadow-glow',
  '--bg-image',
];

export function applyAppTheme(temaKey) {
  const t = APP_THEMES[temaKey];
  const root = document.documentElement;
  if (!t) {
    clearAppTheme();
    return;
  }
  root.style.setProperty('--primary',        t.primary);
  root.style.setProperty('--primary-2',      t.primary2);
  root.style.setProperty('--primary-soft',   t.primarySoft);
  root.style.setProperty('--primary-soft-2', t.primarySoft2);
  root.style.setProperty('--primary-line',   t.primaryLine);
  root.style.setProperty('--shadow-glow',    `0 0 0 3px ${t.glow}`);
  root.style.setProperty(
    '--bg-image',
    `radial-gradient(circle at 0% 0%, ${t.bgImage1} 0, transparent 45%), ` +
    `radial-gradient(circle at 100% 100%, ${t.bgImage2} 0, transparent 45%)`
  );
}

export function clearAppTheme() {
  const root = document.documentElement;
  for (const k of VAR_KEYS) root.style.removeProperty(k);
}
